"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AbstractStrategyConverter_1 = require("./AbstractStrategyConverter");
/**
 * SingleTargetStrategyConverter.
 *
 * @author RV
 */


var SingleTargetStrategyConverter =
/*#__PURE__*/
function (_AbstractStrategyConv) {
  _inherits(SingleTargetStrategyConverter, _AbstractStrategyConv);

  function SingleTargetStrategyConverter() {
    _classCallCheck(this, SingleTargetStrategyConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SingleTargetStrategyConverter).apply(this, arguments));
  }

  return SingleTargetStrategyConverter;
}(AbstractStrategyConverter_1.AbstractStrategyConverter);

exports.SingleTargetStrategyConverter = SingleTargetStrategyConverter;